import { CloudDone, Spa } from "@mui/icons-material";
import axios from "axios";
import moment from "moment-timezone";
import html2pdf from "html2pdf.js";
import React, { useEffect, useState } from "react";
import configs, { getParameterByName } from "../Constants";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Currencies from "../root/currency";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import Card from "@mui/material/Card";
import { useIntl } from "react-intl";
import { Box, IconButton, Grid, Typography, Divider, CardContent, CircularProgress } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import PrintIcon from "@mui/icons-material/Print";
import TableChartIcon from "@mui/icons-material/TableChart";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const Reports = () => {
  const [statusType, setStatusType] = useState("inProgressOrders");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [showMostOrdered, setShowMostOrdered] = useState(false);
  const [handleDate, setHandleDate] = useState([]);
  const [fliterData, setFilterData] = useState([]);
  const [mostOrdered, setMostOrdered] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [report, setReport] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState("Since Open");
  const [todaySummary, setTodaySummary] = useState(true);
  const [mostFilter, setMostFilter] = useState("byDate");
  const [value, setValue] = React.useState(1);
  const [payViaFilter, setPayViaFilter] = useState("All");
  const [orderDetails, setOrderDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [customDate, setCustomDate] = useState(false);
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const tdStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
  };
  const thStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
  };
  let baseURL = configs.baseURL;
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";

  const userId = userData ? userData.sub : " ";
  console.log(baseURL + "/api/orders/report/" + userId);

  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  let merchCode = merchantData ? merchantData.merchantCode : "";
  if (userData && userData.role == 'FRANCHISE-ADMIN' && localStorage.getItem("branch-merchants")) {
    let branchMer = localStorage.getItem("branch-merchants");
    branchMer = branchMer ? JSON.parse(branchMer) : [];
    if (branchMer.length) {
      merchCode = merchCode + '-' + branchMer.join('-');
    }
  }
  const getCatByUser = `${baseURL}/api/categories?merchantCode=${merchCode}`;
  const getProductByUser = `${baseURL}/api/products?merchantCode=${merchCode}`;
  let currency = Currencies.filter(
    (curen) => curen.abbreviation == merchantData.currency
  );
  //console.log(currency)
  let SelectCurrency = currency && currency[0] ? currency[0].symbol : "";
  console.log(SelectCurrency);
  console.log(orderDetails);

  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });

  useEffect(() => {
    handleSummaryPeriod("Today");
  }, []);

  const orderStatus1 = (e) => {
    let status = e.target.value;
    if (status === "cancel") {
      let orderItems =
        report.length && report.filter((item) => item.isCanceled);
      setFilterData(orderItems);
      setIsSearch(true);
    } else {
      setFilterData(report);
      setIsSearch(false);
    }
  };


  const downloadAsExcel = () => {
    console.log("fullReports", fullReports);
    console.log("Downloading as Excel...");

    let excelData = [];

    // Check the selected filter (most ordered, least ordered, etc.)
    if (mostFilter === "itemWise") {
      excelData = aggregateItemWise().map(item => ({
        "Category": item.category,
        "Item": item.name,
        "Quantity Sold": item.isWeight ? "-" : item.quantity,
        "Weight Sold": item.isWeight ? (item.weight >= 1000 ? `${(item.weight / 1000).toFixed(2)} kg` : `${item.weight} g`) : "-",
        "Unit Price": item.isWeight ? formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "") + '/kg' : formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, ""),
        "Total Revenue": item.revenue.toFixed(2)
      }));
    } else if (mostFilter === "mostOrdered" || mostFilter === "leastOrdered") {
      // Aggregate orders based on most/least ordered items
      excelData = aggregateOrders(); // Get sorted and aggregated orders
    } else {
      // Default case: Generate Excel based on the full reports
      excelData = fullReports.map((row) => {
        const discountAmount = row.discountAmount ? row.discountAmount : 0;

        return {
          "Token /Tabel Number": row.number,
          "Order Type":
            row.orderType === "Eat In"
              ? "Eat In"
              : row.orderType === "Table Order"
                ? "Table Order"
                : "Take Away",
          "Price (Inc Tax)":
            row.discountType === "discount" || row.discountType === "price"
              ? row.totalPrice - discountAmount
              : row.totalPrice - (row.totalPrice * discountAmount) / 100,
          Time: moment(`${row.createdAt}`).tz(merchantData.timezone).format("DD-MM-YYYY h:m a"),

          Payment:
            row.payVia === "CASH"
              ? "Cash"
              : row.payVia === "UPI"
                ? "UPI"
                : row.payVia === "CARD"
                  ? "Card"
                  : row.payVia === "COUPON"
                    ? "Coupon"
                    : "UPI",
          "Merchant": row.userId
        };
      });
    }

    // Generate the Excel sheet from the aggregated data
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "sales_report.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const downloadAsPDF = () => {
    const inputId = (value === 0) ? "pdfTarget" : "pdfSummaryTarget";
    const input = document.getElementById(inputId);

    if (!input) {
      console.error("Element not found for PDF capture.");
      return;
    }

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Sales_Report.pdf");
    });
  };

  const handlePrint = (summaryData) => {
    let printDetails = {};

    printDetails.printType = "summary-report";
    printDetails.summaryData = summaryData;
    let isAndroid = false;
    if (window.PrintInterface) {
      isAndroid = true;
      window.PrintInterface.print(JSON.stringify(printDetails));

    }
    if (!isAndroid && window?.chrome?.webview?.postMessage) {
      window.chrome.webview.postMessage(printDetails);
    }
  };

  const orderListHandler = (itemId) => {
    let orderItems = report.filter((item) => item.id === itemId);
    setOrderDetails(orderItems[0]);
    setIsOpen(true);
  };

  let fullReports = isSearch ? fliterData : report;
  console.log(fullReports);

  const handleMostOrdered = () => {
    setShowMostOrdered(true);
    const orderCounts = {};
    console.log("orders", fullReports);
    fullReports && fullReports?.forEach((order) => {
      order.orderItems.forEach((item) => {
        if (orderCounts[item.name]) {
          orderCounts[item.name] += item.quantity;
        } else {
          orderCounts[item.name] = item.quantity;
        }
      });
    });

    const sortedOrders = Object.entries(orderCounts)
      .sort((a, b) => b[1] - a[1])
      .map(([name, quantity]) => ({ name, quantity }));

    setMostOrdered(sortedOrders);
  };

  const handleClose = (period) => {
    if (period) {
      setSelectedPeriod(period);
      handleSummaryPeriod(period);
    }
  };

  const handleSummaryPeriod = (period) => {
    setTodaySummary(true);
    let startDate, endDate;

    switch (period) {
      case "Yesterday":
        startDate = moment().tz(merchantData.timezone || moment.tz.guess()).subtract(1, "days").startOf("day");
        endDate = moment().tz(merchantData.timezone || moment.tz.guess()).subtract(1, "days").endOf("day");
        break;
      case "Last Week":
        startDate = moment().tz(merchantData.timezone || moment.tz.guess()).subtract(1, "weeks").startOf("day");
        endDate = moment().tz(merchantData.timezone || moment.tz.guess()).endOf("day");
        break;
      case "Last Month":
        startDate = moment().tz(merchantData.timezone || moment.tz.guess()).subtract(1, "months").startOf("month");
        endDate = moment().tz(merchantData.timezone || moment.tz.guess()).subtract(1, "months").endOf("month");
        break;
      case "Custom Date":
        setCustomDate(true);
        return;
      case "Today":
        startDate = moment().tz(merchantData.timezone || moment.tz.guess()).startOf('day');
        endDate = moment().tz(merchantData.timezone || moment.tz.guess()).endOf('day');
        break;
      default:
        startDate = moment().tz(merchantData.timezone || moment.tz.guess()).startOf("day");
        endDate = moment().tz(merchantData.timezone || moment.tz.guess()).endOf("day");
    }
    console.log(startDate, endDate);
    setFromDate(startDate ? startDate.format("YYYY-MM-DD") : undefined);
    setToDate(endDate ? endDate.format("YYYY-MM-DD") : undefined);
  };

  useEffect(() => {
    axios.get(getCatByUser).then((response) => {
      console.log(response.data);
      setCategories(response.data);
    });
    axios.get(getProductByUser).then((response) => {
      console.log(response.data);
      setProducts(response.data);
    });

  }, []);

  useEffect(() => {
    setIsLoading(true);
    let startDate, endDate;
    if (!fromDate || !toDate) {
      startDate = moment().tz(merchantData.timezone || moment.tz.guess()).startOf("day");
      endDate = moment().tz(merchantData.timezone || moment.tz.guess()).endOf("day");
      console.log(startDate, endDate);
      setFromDate(startDate ? startDate.format("YYYY-MM-DD") : undefined);
      setToDate(endDate ? endDate.format("YYYY-MM-DD") : undefined);
    }
    const qFrom = fromDate || (startDate ? startDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
    const qTo = toDate || (endDate ? endDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));

    axios
      .get(
        `${baseURL}/api/orders/recent?merchantCode=${merchCode}`
      )
      .then((res) => {
        let tzRes = res.data.map(rp => { rp.createdAt = moment(rp.createdAt).tz(merchantData.timezone); return rp });
        let recents = tzRes.filter((item) => {
          const itemDt = moment(item.createdAt);
          const fromStr = fromDate || (startDate ? startDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
          const toStr = toDate || (endDate ? endDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"));
          const from = moment.tz(fromStr, "YYYY-MM-DD", merchantData.timezone || moment.tz.guess()).startOf("day");
          const to = moment.tz(toStr, "YYYY-MM-DD", merchantData.timezone || moment.tz.guess()).endOf("day");
          return itemDt.isSameOrAfter(from) && itemDt.isSameOrBefore(to);
        });



        let isArchive = false;
        if (qFrom) {
          const fromMoment = moment.tz(qFrom, "YYYY-MM-DD", merchantData.timezone || moment.tz.guess());
          if (moment().diff(fromMoment, 'months', true) >= 2) {
            isArchive = true;
          }
        }

        axios
          .get(
            `${baseURL}/api/orders/report/${merchCode}?start_date=${qFrom}&end_date=${qTo}&archive=${isArchive}`
          )
          .then((response) => {
            console.log(response.data);
            console.log(recents);
            let combinedData = [...recents, ...response.data];
            
            const from = moment.tz(qFrom, "YYYY-MM-DD", merchantData.timezone || moment.tz.guess()).startOf("day");
            const to = moment.tz(qTo, "YYYY-MM-DD", merchantData.timezone || moment.tz.guess()).endOf("day");
            
            combinedData = combinedData.filter((item) => {
              const itemDt = moment(item.createdAt).tz(merchantData.timezone || moment.tz.guess());
              return itemDt.isSameOrAfter(from) && itemDt.isSameOrBefore(to);
            });

            combinedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setReport(combinedData);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching report data:", error);
            setIsLoading(false);
          });
      })
      .catch((error) => {
        console.error("Error fetching recent data:", error);
        setIsLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchTrigger, baseURL, merchCode]);
  const totalAmount = fullReports
    ? fullReports.reduce((sum, item) => item.orderType?.toLowerCase() === 'refund' ? sum - item.totalPrice : sum + item.totalPrice, 0)
    : 0;
  const cancelOrders = fullReports
    ? fullReports.filter((item) => item.isCanceled === true)
    : 0;
  const totalTax = fullReports
    ? fullReports.reduce((sum, item) => item.orderType?.toLowerCase() === 'refund' ? sum - item.taxPrice : sum + item.taxPrice, 0)
    : 0;
  const cgst = (totalTax / 2).toFixed(2);
  const sgst = (totalTax / 2).toFixed(2);
  const eposOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "EPOS")
    : 0;
  const sokOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "Self Order")
    : 0;
  const tokOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "Table Order")
    : 0;
  const oosOrders = fullReports
    ? fullReports.filter((item) => item.orderSource === "Online Order")
    : 0;

  const eposAmount = eposOrders
    ? eposOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;
  const sokAmount = sokOrders
    ? sokOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;
  const tokAmount = tokOrders
    ? tokOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;
  const oosAmount = oosOrders
    ? oosOrders.reduce((acc, item) => item.orderType?.toLowerCase() === 'refund' ? acc - item.totalPrice : acc + item.totalPrice, 0)
    : 0;

  const refundOrders = fullReports
    ? fullReports.filter((item) => item.orderType?.toLowerCase() === 'refund')
    : [];
  const totalRefundAmount = refundOrders.reduce((acc, item) => acc + item.totalPrice, 0);
  const totalRefundOrders = refundOrders.length;

  const discount = fullReports
    ? fullReports.reduce((acc, item) => acc + (item.discountAmount || 0), 0)
    : 0;
  const netAmount = totalAmount - totalTax;
  const total = totalAmount;
  const igst = 0;

  const payViaDistribution = fullReports
    ? fullReports.reduce((acc, ord) => {
      const method = ord.payVia?.toUpperCase() || merchantData?.defaultPaymentMethod?.toUpperCase() || "CASH";
      const val = ord.orderType?.toLowerCase() === 'refund' ? -ord.totalPrice : ord.totalPrice;
      acc[method] = (acc[method] || 0) + val;
      return acc;
    }, {})
    : {};

  // console.log(cancelOrders);

  const { formatMessage: t, locale, setLocale } = useIntl();

  const handleFilterChange = (event) => {
    const filter = event.target.value;
    setMostFilter(filter);

    if (filter.toLowerCase() === "all") {
      setShowMostOrdered(false);
    } else {
      setShowMostOrdered(true);
    }
  };

  const aggregateOrders = () => {
    const orderCounts = {};
    console.log(fullReports);
    fullReports && fullReports?.forEach((order) => {
      const isRefund = order.orderType?.toLowerCase() === "refund";
      order.orderItems.forEach((item) => {
        orderCounts[item.name] = (orderCounts[item.name] || 0) + (isRefund ? -item.quantity : item.quantity);
      });
    });

    // Convert aggregated data into a sorted array based on quantity
    return Object.entries(orderCounts)
      .map(([name, quantity]) => ({ name, quantity }))
      .sort((a, b) =>
        mostFilter === "mostOrdered"
          ? b.quantity - a.quantity
          : a.quantity - b.quantity
      );
  };

  const aggregateItemWise = () => {
    const stats = {};
    fullReports && fullReports?.forEach((order) => {
      const isRefund = order.orderType?.toLowerCase() === "refund";
      order.orderItems?.forEach((item) => {
        if (!stats[item.name]) {
          stats[item.name] = { quantity: 0, revenue: 0, weight: 0, isWeight: false };
        }
        const isWeight = item.select_type === "weight" || (item.is_weight_type && item.weight_price > 0);
        stats[item.name].isWeight = isWeight;

        if (isWeight) {
          const weight = isRefund ? -item.quantity : item.quantity;
          stats[item.name].weight += weight;
          // In this system, price for weight-type items is stored as weight_price which is per 1000g (1kg)
          stats[item.name].revenue += (weight / 1000) * item.price;
          stats[item.name].unitPrice = item.price;
        } else {
          stats[item.name].quantity += isRefund ? -item.quantity : item.quantity;
          stats[item.name].revenue += isRefund ? -(item.quantity * item.price) : (item.quantity * item.price);
          stats[item.name].unitPrice = item.price;
        }

        const prod = products.find(prd => prd._id == item._id || prd.id == item._id);
        if (prod) {
          const cat = categories.find(cat => cat._id == prod.category || cat.id == prod.category);
          stats[item.name].category = cat ? cat.name : "Uncategorized";
        } else {
          stats[item.name].category = "Uncategorized";
        }
      });
    });
    return Object.entries(stats).map(([name, { quantity, revenue, category, weight, isWeight, unitPrice }]) => ({
      name,
      quantity,
      revenue,
      category,
      weight,
      isWeight,
      unitPrice
    })).sort((a, b) => {
      const nameA = a.category.toUpperCase();
      const nameB = b.category.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  };

  const groupItemsByCategory = () => {
    const items = aggregateItemWise();
    const grouped = {};

    items.forEach(item => {
      if (!grouped[item.category]) {
        grouped[item.category] = [];
      }
      grouped[item.category].push(item);
    });

    return grouped;
  };

  const groupByDate = () => {
    const grouped = {};
    if (!fullReports) return [];
    
    fullReports.forEach(ord => {
      const dateStr = moment(ord.createdAt).tz(merchantData?.timezone || 'UTC').format("YYYY-MM-DD");
      if (!grouped[dateStr]) {
        grouped[dateStr] = {
          date: dateStr,
          totalOrders: 0,
          totalAmount: 0,
          totalTax: 0,
          netAmount: 0
        };
      }
      grouped[dateStr].totalOrders += 1;
      grouped[dateStr].totalAmount += (ord.totalPrice || 0);
      grouped[dateStr].totalTax += (ord.tax || 0);
      grouped[dateStr].netAmount += ((ord.totalPrice || 0) - (ord.tax || 0));
    });
    
    return Object.values(grouped).sort((a, b) => b.date.localeCompare(a.date));
  };

  const groupByWeekly = () => {
    const grouped = {};
    if (!fullReports) return [];
    
    fullReports.forEach(ord => {
      const momentDate = moment(ord.createdAt).tz(merchantData?.timezone || 'UTC');
      const startOfWeek = momentDate.clone().startOf('isoWeek').format("YYYY-MM-DD");
      const endOfWeek = momentDate.clone().endOf('isoWeek').format("YYYY-MM-DD");
      const weekStr = `${startOfWeek} to ${endOfWeek}`;
      
      if (!grouped[weekStr]) {
        grouped[weekStr] = {
          week: weekStr,
          startOfWeek: startOfWeek,
          totalOrders: 0,
          totalAmount: 0,
          totalTax: 0,
          netAmount: 0
        };
      }
      grouped[weekStr].totalOrders += 1;
      grouped[weekStr].totalAmount += (ord.totalPrice || 0);
      grouped[weekStr].totalTax += (ord.tax || 0);
      grouped[weekStr].netAmount += ((ord.totalPrice || 0) - (ord.tax || 0));
    });
    
    return Object.values(grouped).sort((a, b) => b.startOfWeek.localeCompare(a.startOfWeek));
  };

  const allOrders = aggregateOrders();
  console.log(allOrders);
  let filteredOrders = [...allOrders];

  if (mostFilter === "mostOrdered") {
    filteredOrders.sort((a, b) => b.quantity - a.quantity);
  } else if (mostFilter === "leastOrdered") {
    filteredOrders.sort((a, b) => a.quantity - b.quantity);
  }
  console.log(filteredOrders);
  const backHandler = () => {
    setShowMostOrdered(false);
    setTodaySummary(false);
    setMostFilter("all");
  };

  const handlePayViaFilter = (value) => {
    setPayViaFilter(value);

    if (value === "All") {
      setFilterData(report); // show all orders
      setIsSearch(false);
    } else {
      const filtered = report.filter(
        (item) =>
          item.payVia && item.payVia.toUpperCase() === value.toUpperCase()
      );
      setFilterData(filtered);
      setIsSearch(true);
    }
  };

  const handleDateView = () => {
    setValue(0); // Switch to Date View
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    setFromDate(formattedDate);
    setToDate(formattedDate);
  };

  const handleSummaryView = () => {
    setValue(1); // Switch to Summary View
    setFromDate(null);
    setToDate(null);
  };

  return (
    <div className="container bg-light">
      <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 align="left" style={{ margin: 0 }}>Reports</h4>
        
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{fontSize: '16px', fontWeight: 'bold', color: '#333'}}>From:</label>
            <input
              type="date"
              onChange={(e) => {
                setFromDate(e.target.value);
                setSelectedPeriod("Custom Date");
                setCustomDate(true);
              }}
              style={{
                borderRadius: "5px",
                padding: "8px 12px",
                outline: "none",
                border: "1px solid #ccc",
                fontSize: "16px"
              }}
              value={fromDate || ""}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{fontSize: '16px', fontWeight: 'bold', color: '#333'}}>To:</label>
            <input
              type="date"
              onChange={(e) => {
                setToDate(e.target.value);
                setSelectedPeriod("Custom Date");
                setCustomDate(true);
              }}
              style={{
                borderRadius: "5px",
                padding: "8px 12px",
                outline: "none",
                border: "1px solid #ccc",
                fontSize: "16px"
              }}
              value={toDate || ""}
            />
          </div>
          <button
            disabled={isLoading}
            onClick={() => setFetchTrigger(prev => prev + 1)}
            style={{
              padding: "8px 16px",
              borderRadius: "5px",
              backgroundColor: isLoading ? "#0056b3" : "#007bff",
              color: "white",
              cursor: isLoading ? "not-allowed" : "pointer",
              border: "none",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              opacity: isLoading ? 0.7 : 1
            }}
          >
            {isLoading && <CircularProgress size={16} style={{ color: "white" }} />}
            Show Report
          </button>
        </div>

        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "8px 16px",
            borderRadius: "50px",
            backgroundColor: "white",
            color: "#007bff",
            cursor: "pointer",
            border: "1px solid #007bff",
          }}
        >
          Refresh
        </button>
      </div>

      <div
        style={{
          padding: "12px",
          backgroundColor: "white",
          borderRadius: "10px",
          margin: "10px",
          height: "85vh",
          overflow: "hidden",
          overflowY: "scroll"
        }}
      >
        {isLoading ? (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '400px' }}>
            <CircularProgress size={60} />
            <Typography variant="h6" style={{ marginTop: '20px', color: '#666' }}>Fetching reports...</Typography>
          </div>
        ) : (
          <React.Fragment>
        {/* SUMMARY SECTION */}
        <div id="pdfSummaryTarget" style={{ marginBottom: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
            <h3 style={{ margin: 0 }}>Summary</h3>
            <span style={{ fontSize: '14px', color: '#666' }}>
               ({moment(fromDate).tz(merchantData.timezone).format("DD/MM/YYYY")} 
               {toDate && fromDate !== toDate ? ` - ${moment(toDate).tz(merchantData.timezone).format("DD/MM/YYYY")}` : ""})
            </span>
            <IconButton onClick={() => handlePrint({
                    date: moment(fromDate).tz(merchantData.timezone).format("DD/MM/YYYY"),
                    totalOrders: (fullReports?.length || 0),
                    totalAmount: totalAmount.toFixed(2),
                    tax: totalTax.toFixed(2),
                    discount: discount.toFixed(2),
                    netAmount: netAmount.toFixed(2),
                    cgst: cgst,
                    sgst: sgst,
                    igst: igst.toFixed(2),
                    total: total.toFixed(2),
                    totalRefundOrders,
                    totalRefundAmount: totalRefundAmount.toFixed(2),
                    payViaDistribution
                  })} color="primary" className="no-print" size="small" style={{ marginLeft: 'auto' }}>
              <PrintIcon />
            </IconButton>
          </div>

          <Grid container spacing={2}>
            {/* Sales & Orders Card */}
            <Grid item xs={12} sm={6} md={3}>
              <Card variant="outlined" style={{ height: '100%', borderColor: '#1976d2', borderTopWidth: '4px' }}>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom variant="subtitle2">Sales & Orders</Typography>
                  <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                    {formatter.format(totalAmount).replace('JMD', 'J$')}
                  </Typography>
                  <Divider style={{ margin: '10px 0' }} />
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                     <span>Total Orders:</span>
                     <strong>{fullReports ? fullReports.length : 0}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                     <span>Net Amount:</span>
                     <strong>{formatter.format(netAmount).replace('JMD', 'J$')}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                     <span>Total Tax:</span>
                     <strong>{formatter.format(totalTax).replace('JMD', 'J$')}</strong>
                  </div>
                </CardContent>
              </Card>
            </Grid>

            {/* Source Breakdown Card */}
            <Grid item xs={12} sm={6} md={3}>
              <Card variant="outlined" style={{ height: '100%', borderColor: '#ed6c02', borderTopWidth: '4px' }}>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom variant="subtitle2">Source Breakdown</Typography>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px' }}>
                     <span>POS:</span>
                     <strong>{eposOrders.length} ({formatter.format(eposAmount).replace('JMD', 'J$')})</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px' }}>
                     <span>Online:</span>
                     <strong>{oosOrders.length} ({formatter.format(oosAmount).replace('JMD', 'J$')})</strong>
                  </div>
                  {merchantData?.bizVertical?.toUpperCase() === 'RESTAURANT' && (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px' }}>
                         <span>Table:</span>
                         <strong>{tokOrders.length} ({formatter.format(tokAmount).replace('JMD', 'J$')})</strong>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px' }}>
                         <span>Kiosk:</span>
                         <strong>{sokOrders.length} ({formatter.format(sokAmount).replace('JMD', 'J$')})</strong>
                      </div>
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Payment Methods Card */}
            <Grid item xs={12} sm={6} md={3}>
              <Card variant="outlined" style={{ height: '100%', borderColor: '#2e7d32', borderTopWidth: '4px' }}>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom variant="subtitle2">Payment Methods</Typography>
                  {Object.entries(payViaDistribution).map(([method, amount]) => (
                    <div key={method} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px' }}>
                       <span>{method}:</span>
                       <strong>{formatter.format(amount).replace('JMD', 'J$')}</strong>
                    </div>
                  ))}
                  {Object.keys(payViaDistribution).length === 0 && (
                    <Typography variant="body2" color="textSecondary">No payments yet</Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Refunds & Discounts Card */}
            <Grid item xs={12} sm={6} md={3}>
              <Card variant="outlined" style={{ height: '100%', borderColor: '#d32f2f', borderTopWidth: '4px' }}>
                <CardContent>
                  <Typography color="textSecondary" gutterBottom variant="subtitle2">Refunds & Discounts</Typography>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px', color: '#d32f2f' }}>
                     <span>Total Refunds:</span>
                     <strong>{totalRefundOrders}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px', color: '#d32f2f' }}>
                     <span>Refund Amount:</span>
                     <strong>{formatter.format(totalRefundAmount).replace('JMD', 'J$')}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '4px', color: '#9c27b0' }}>
                     <span>Discounts:</span>
                     <strong>{formatter.format(discount).replace('JMD', 'J$')}</strong>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
        
        <Divider style={{ margin: '5px 0' }} />

        {/* DETAILS FILTERS */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'center', marginBottom: '10px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
          <Typography variant="h6" style={{ marginRight: '10px', fontWeight: 'bold' }}>Details View</Typography>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, justifyContent: 'center' }}>
            <label style={{fontSize: '16px', fontWeight: 'bold', color: '#333'}}>Group By:</label>
            <select
              value={mostFilter}
              onChange={handleFilterChange}
              style={{
                border: "1px solid #ccc",
                outline: "none",
                width: "200px",
                padding: "8px 12px",
                borderRadius: "5px",
                fontSize: "16px"
              }}
            >
              <option value="byDate">By Date</option>
              <option value="byCategories">By Categories</option>
              <option value="itemWise">By Items</option>
              <option value="byWeekly">By Weekly</option>
            </select>
          </div>



          <div style={{ marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <label style={{fontSize: '12px', color: '#777'}}>Download</label>
            <div>
               <IconButton onClick={downloadAsExcel} title="Download Excel" style={{ color: '#1D6F42' }}>
                 <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
                   <path fill="currentColor" d="M14,2H6C4.89,2 4,2.89 4,4V20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20Z" />
                 </svg>
               </IconButton>
               <IconButton color="error" onClick={downloadAsPDF} title="Download PDF">
                 <PictureAsPdfIcon />
               </IconButton>
            </div>
          </div>
        </div>

        {/* DETAILS TABLE */}
        <div id="pdfTarget">
           {mostFilter === "byDate" && (
             <div style={{ overflowX: "auto" }}>
               <table className="r-responsive-table" style={{ width: "100%", fontSize: "16px", borderCollapse: "collapse" }}>
                 <thead style={{ background: "#f1f1f1" }}>
                   <tr>
                     <th style={thStyle}>Date</th>
                     <th style={thStyle}>Total Orders</th>
                     <th style={thStyle}>Net Amount</th>
                     <th style={thStyle}>Tax</th>
                     <th style={thStyle}>Total Amount</th>
                   </tr>
                 </thead>
                 <tbody>
                   {groupByDate().length ? (
                     groupByDate().map((row, index) => (
                       <tr key={index} style={{ textAlign: "center", borderBottom: '1px solid #eee' }}>
                         <td style={tdStyle}>{moment(row.date).format('DD MMM YYYY')}</td>
                         <td style={tdStyle}>{row.totalOrders}</td>
                         <td style={tdStyle}>{formatter.format(row.netAmount).replace('JMD', 'J$')}</td>
                         <td style={tdStyle}>{formatter.format(row.totalTax).replace('JMD', 'J$')}</td>
                         <td style={tdStyle}>{formatter.format(row.totalAmount).replace('JMD', 'J$')}</td>
                       </tr>
                     ))
                   ) : (
                     <tr><td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>No data available</td></tr>
                   )}
                 </tbody>
               </table>
             </div>
           )}

           {mostFilter === "byWeekly" && (
             <div style={{ overflowX: "auto" }}>
               <table className="r-responsive-table" style={{ width: "100%", fontSize: "16px", borderCollapse: "collapse" }}>
                 <thead style={{ background: "#f1f1f1" }}>
                   <tr>
                     <th style={thStyle}>Week Of</th>
                     <th style={thStyle}>Total Orders</th>
                     <th style={thStyle}>Net Amount</th>
                     <th style={thStyle}>Tax</th>
                     <th style={thStyle}>Total Amount</th>
                   </tr>
                 </thead>
                 <tbody>
                   {groupByWeekly().length ? (
                     groupByWeekly().map((row, index) => (
                       <tr key={index} style={{ textAlign: "center", borderBottom: '1px solid #eee' }}>
                         <td style={tdStyle}>{row.week}</td>
                         <td style={tdStyle}>{row.totalOrders}</td>
                         <td style={tdStyle}>{formatter.format(row.netAmount).replace('JMD', 'J$')}</td>
                         <td style={tdStyle}>{formatter.format(row.totalTax).replace('JMD', 'J$')}</td>
                         <td style={tdStyle}>{formatter.format(row.totalAmount).replace('JMD', 'J$')}</td>
                       </tr>
                     ))
                   ) : (
                     <tr><td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>No data available</td></tr>
                   )}
                 </tbody>
               </table>
             </div>
           )}

           {mostFilter === "byCategories" && (

              <div style={{ overflowX: "auto" }}>
                <table className="r-responsive-table" style={{ width: "100%", fontSize: "16px", borderCollapse: "collapse" }}>
                  <thead style={{ backgroundColor: "#f1f1f1" }}>
                    <tr>
                      <th style={thStyle}>Item</th>
                      <th style={thStyle}>Qnty Sold</th>
                      <th style={thStyle}>Weight Sold</th>
                      <th style={thStyle}>Unit Price</th>
                      <th style={thStyle}>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(groupItemsByCategory()).length > 0 ? (
                      Object.entries(groupItemsByCategory()).map(([category, items], catIdx) => {
                        const categorySubtotal = items.reduce((sum, item) => sum + item.revenue, 0);
                        return (
                          <React.Fragment key={catIdx}>
                            <tr style={{ backgroundColor: "#e0e0e0" }}>
                              <td colSpan="5" style={{ ...tdStyle, fontWeight: "bold", fontSize: "18px", textAlign: "left", padding: "10px" }}>
                                {category}
                              </td>
                            </tr>
                            {items.map((item, idx) => (
                              <tr key={idx} style={{ backgroundColor: "#ffffff", borderBottom: '1px solid #eee' }}>
                                <td style={tdStyle}>{item.name}</td>
                                <td style={tdStyle}>{item.isWeight ? "-" : item.quantity}</td>
                                <td style={tdStyle}>
                                  {item.isWeight
                                    ? item.weight >= 1000
                                      ? `${(item.weight / 1000).toFixed(2)} kg`
                                      : `${item.weight} g`
                                    : "-"}
                                </td>
                                <td style={tdStyle}>
                                  {item.isWeight ? formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "") + '/kg' : formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "")}
                                </td>
                                <td style={tdStyle}>{item.revenue.toFixed(2)}</td>
                              </tr>
                            ))}
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                              <td colSpan="2" style={{ ...tdStyle, fontWeight: "bold", textAlign: "right", padding: "10px", fontSize: "14px" }}>
                                {category} Subtotal:
                              </td>
                              <td colSpan="2" style={{ ...tdStyle, backgroundColor: "#f5f5f5" }}></td>
                              <td style={{ ...tdStyle, fontWeight: "bold", padding: "10px" }}>
                                {categorySubtotal.toFixed(2)}
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr><td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>No data available</td></tr>
                    )}
                    {Object.keys(groupItemsByCategory()).length > 0 && (
                      <tr style={{ backgroundColor: "#d0d0d0", fontWeight: "bold" }}>
                        <td colSpan="4" style={{ ...tdStyle, textAlign: "right", padding: "15px", fontSize: "18px" }}>Grand Total:</td>
                        <td style={{ ...tdStyle, padding: "15px", fontSize: "18px" }}>
                          {Object.values(groupItemsByCategory())
                            .flat()
                            .reduce((sum, item) => sum + item.revenue, 0)
                            .toFixed(2)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            
           )}

           {mostFilter === "itemWise" && (
              <div style={{ overflowX: "auto" }}>
                <table className="r-responsive-table" style={{ width: "100%", fontSize: "16px", borderCollapse: "collapse" }}>
                  <thead style={{ backgroundColor: "#f1f1f1" }}>
                    <tr>
                      <th style={thStyle}>Item</th>
                      <th style={thStyle}>Category</th>
                      <th style={thStyle}>Qnty Sold</th>
                      <th style={thStyle}>Weight Sold</th>
                      <th style={thStyle}>Unit Price</th>
                      <th style={thStyle}>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {aggregateItemWise().length > 0 ? (
                      aggregateItemWise().sort((a,b) => a.name.localeCompare(b.name)).map((item, idx) => (
                        <tr key={idx} style={{ backgroundColor: "#ffffff", borderBottom: '1px solid #eee' }}>
                          <td style={tdStyle}>{item.name}</td>
                          <td style={tdStyle}>{item.category}</td>
                          <td style={tdStyle}>{item.isWeight ? "-" : item.quantity}</td>
                          <td style={tdStyle}>
                            {item.isWeight
                              ? item.weight >= 1000
                                ? `${(item.weight / 1000).toFixed(2)} kg`
                                : `${item.weight} g`
                              : "-"}
                          </td>
                          <td style={tdStyle}>
                            {item.isWeight ? formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "") + '/kg' : formatter.format(item.unitPrice).replace('JMD', 'J$').replace(/\s+/, "")}
                          </td>
                          <td style={tdStyle}>{item.revenue.toFixed(2)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>No data available</td></tr>
                    )}
                    {aggregateItemWise().length > 0 && (
                      <tr style={{ backgroundColor: "#d0d0d0", fontWeight: "bold" }}>
                        <td colSpan="5" style={{ ...tdStyle, textAlign: "right", padding: "15px", fontSize: "18px" }}>Grand Total:</td>
                        <td style={{ ...tdStyle, padding: "15px", fontSize: "18px" }}>
                          {aggregateItemWise()
                            .reduce((sum, item) => sum + item.revenue, 0)
                            .toFixed(2)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
           )}
        </div>
        </React.Fragment>
        )}
      </div>
      <Dialog className="dialog-box" maxWidth="md" fullWidth={true} open={isOpen}>
        <div style={{ padding: "20px" }} className="order-tab">
          <h5 align="center">
            Order summary token : #
            <span style={{ fontSize: "35px" }}>
              {orderDetails && orderDetails.number}
            </span>
          </h5>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "16px", marginTop: '20px' }}>
            <thead>
              <tr style={{ background: "#f1f1f1" }}>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Qty</th>
                <th style={thStyle}>Price</th>
              </tr>
            </thead>
            <tbody>
              {orderDetails &&
                orderDetails.orderItems.map((item, key) => (
                  <tr key={key} style={{ borderBottom: "1px solid #ddd" }}>
                    <td style={tdStyle}>{item.name}</td>
                    <td style={tdStyle}>
                      {item.select_type === "weight"
                        ? item.quantity >= 1000
                          ? `${(item.quantity / 1000).toFixed(
                            item.quantity % 1000 === 0 ? 0 : 1
                          )} kg`
                          : `${item.quantity} g`
                        : item.quantity}
                    </td>
                    <td style={tdStyle}>{(item.price * item.quantity).toFixed(2)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
            <span style={{ fontWeight: 'bold' }}>Total</span>
            <span style={{ fontWeight: 'bold' }}>{orderDetails && orderDetails.totalPrice.toFixed(2)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: '20px' }}>
            <Button
              variant="outlined"
              color="error"
              onClick={() => setIsOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
export default Reports;
